import { render, staticRenderFns } from "./InspectionCopy.vue?vue&type=template&id=474384ea&"
import script from "./InspectionCopy.vue?vue&type=script&lang=js&"
export * from "./InspectionCopy.vue?vue&type=script&lang=js&"
import style0 from "./InspectionCopy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports